import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Users, Award, Cpu, Plane, Factory } from 'lucide-react';

const About = () => {
  const stats = [
    { icon: BookOpen, label: 'Courses', value: '4+' },
    { icon: Users, label: 'Students', value: '200+' },
    { icon: Award, label: 'Certifications', value: '10+' }
  ];

  const capabilities = [
    {
      icon: Plane,
      title: 'Advanced Drone Systems',
      description: 'Cutting-edge UAV solutions for industrial and agricultural applications'
    },
    {
      icon: Cpu,
      title: 'Semiconductor Innovation',
      description: 'Custom semiconductor design and manufacturing for next-generation technology'
    },
    {
      icon: Factory,
      title: 'Industrial Solutions',
      description: 'Integrated automation systems for modern manufacturing'
    }
  ];

  return (
    <div className="py-12 bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Mission Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl font-bold mb-4 bg-gradient-to-r from-blue-500 to-purple-600 text-transparent bg-clip-text">About JK SemiTech</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            We are a pioneering technology company specializing in advanced drone manufacturing and semiconductor solutions, driving innovation in industrial automation and precision engineering.
          </p>
        </motion.div>

        {/* Stats Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16"
        >
          {stats.map((stat, index) => (
            <div key={index} className="text-center bg-gray-900 p-6 rounded-lg">
              <stat.icon className="h-8 w-8 text-blue-500 mx-auto mb-4" />
              <div className="text-3xl font-bold mb-2 bg-gradient-to-r from-blue-500 to-purple-600 text-transparent bg-clip-text">{stat.value}</div>
              <div className="text-gray-300">{stat.label}</div>
            </div>
          ))}
        </motion.div>

        {/* Capabilities Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="mb-16"
        >
          <h2 className="text-3xl font-bold text-center mb-12 bg-gradient-to-r from-blue-500 to-purple-600 text-transparent bg-clip-text">
            Our Capabilities
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {capabilities.map((capability, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 * index }}
                className="bg-gray-900 rounded-lg p-6 transform hover:scale-105 transition-all duration-300"
              >
                <capability.icon className="h-12 w-12 text-blue-500 mb-4" />
                <h3 className="text-xl font-semibold mb-3">{capability.title}</h3>
                <p className="text-gray-400">{capability.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Vision Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg p-8 text-center"
        >
          <h2 className="text-3xl font-bold mb-4">Our Vision</h2>
          <p className="text-xl">
            To revolutionize industries through cutting-edge drone technology and semiconductor innovations, 
            delivering next-generation solutions that empower businesses with advanced automation and precision engineering capabilities.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default About;